<template>
    <div :class="{ 'page': true, 'game': true, /*'darken': gameEnded,*/ 'fallback': $helpers.browserCheck().isIE }">
        <div class="tiles">
            <div class="tile static correct">
                <div class="flipper">
                    <div class="front">
                        <svg class="title" width="250" height="300" viewBox="0 0 250 300" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">

                            <text text-anchor="middle" y="26%" x="50%" fill="#fff" style="font-size: 34px; font-weight: 500;">
                                <tspan x="50%" dy="0">Aantal</tspan>
                                <tspan x="50%" dy="1.3em">goed</tspan>
                            </text>
                            <text text-anchor="middle" y="25%" fill="#fff" style="font-size: 96px; font-weight: bold;">
                                <tspan x="50%" dy="150px" >{{ correct }}</tspan>
                            </text>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="tile static turns">
                <div class="flipper">
                    <div class="front">
                        <svg class="title" width="250" height="300" viewBox="0 0 250 300" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">

                            <text text-anchor="middle" y="26%" x="50%" fill="#fff" style="font-size: 34px; font-weight: 500;">
                                <tspan x="50%" dy="0">Aantal</tspan>
                                <tspan x="50%" dy="1.3em">pogingen</tspan>
                            </text>
                            <text text-anchor="middle" y="25%" fill="#8ee0ff" style="font-size: 80px; font-weight: bold;">
                                <tspan x="50%" dy="150px" >{{ turn }}/5</tspan>
                            </text>
                        </svg>
                    </div>
                </div>
            </div>
            <div v-for="n in cards" @click="openCard(n)" :class="{ tile: true, open: n.open, good: ( n.open && n.good ) }" >
                <div class="flipper">
                    <div class="front">
                       &nbsp;
                    </div>
                    <div class="back">
                       &nbsp;
                    </div>
                </div>
            </div>
        </div>

        <v-panel darken v-if="gameEnded && correct >= 1">
            <div>
                <h2 class="orange">Gefeliciteerd!</h2>
                <h3>Je hebt <strong>{{ correct }} kans<span v-if="correct !== 1">en</span></strong> bij elkaar&nbsp;gespeeld.</h3>

                <!-- <img class="prijzenpot" src="static/img/prijzenpot.png" /> -->
                <v-prizevisual></v-prizevisual>

                <p>Wil je winnen? Speel dan verder en maak óók nog eens kans op een heel Staatslot.</p>
            </div>
            <router-link slot="button" to="/gegevens" class="button stl"><span>Claim je kans</span></router-link>
        </v-panel>

        <!-- v-panel darken v-else-if="gameEnded">
            <h2 class="light-blue">Helaas...</h2>
            <h3>Je hebt geen kansen gewonnen</h3>

            <p>Morbi pharetra semper nulla, quis vulputate doiam ultrices at. Aliquam hendrerit blandit dui, sit amet p[haretra risus!</p>

            <button class="stl" @click="restartGame">Speel nog een keer</button>

            <v-share></v-share>
        </v-panel -->
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    import { TimelineMax } from '@/vendor';

    import Shares from '@/app/components/Shares';
    import Panel from '@/app/components/Panel';
    import PrizeVisual from '@/app/components/PrizeVisual';

    export default {
        components: {
            'v-panel': Panel,
            'v-share': Shares,
            'v-prizevisual': PrizeVisual
        },

        data()
        {
            return {
                open: 0,
                active: true,
                gameEnded: false
            };
        },

        computed: {
            cards()
            {
                return this.$store.getters.cards;
            },
            correct()
            {
                return this.$store.getters.correct;
            },
            turn()
            {
                return this.$store.getters.turn;
            }
        },

        created()
        {
            this.$store.dispatch( 'newGame' );
        },

        mounted()
        {
            this.$store.dispatch( 'sky', 'light' );
            this.$store.dispatch( 'sun', 'up' );
        },

        methods:
        {
            restartGame()
            {

            },

            openCard( card )
            {
                if( !this.active || card.open )
                {
                    return;
                }
                this.open++;
                if( this.open > 4 )
                {
                    this.active = false;
                }

                this.$store.dispatch( 'turnedCard', card );

                if( this.open >= 5 )
                {
                    setTimeout( () =>
                    {
                        this.gameEnded = true;
                    }, 1000 );
                }
            },

            getAnimateIn()
            {
                let tl = new TimelineMax({ delay: 0.5 });

                tl.staggerFrom( '.tile:not(.static)', 0.3, { scale: 0, opacity: 0 }, 0.05 );
                return tl;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/pages/Game.vue